const placeholder = require('../../data/placeHolderCopy');

module.exports = {
  content: function content() {
    return {
      // Instead of exposing the mixin directly, we're retuning  a function
      // to be initialized the declaring the mixin. This is to avoid
      // inmediate start of code.
      labels: window.raq && window.raq.labels
        ? window.raq.labels : placeholder.labels,
      states: window.raq && window.raq.states
        ? window.raq.states : placeholder.states,
      ctas: window.raq && window.raq.CTAs
        ? window.raq.CTAs : placeholder.CTAs,
      lotTransitDisclaimer: window.raq && window.raq.lotTransitDisclaimer
        ? window.raq.lotTransitDisclaimer : placeholder.lotTransitDisclaimer,
      endpoints: window.raq && window.raq.endpoints
        ? window.raq.endpoints : placeholder.endpoints,
      vehicleCard: window.raq && window.raq.vehicleCard
        ? window.raq.vehicleCard : placeholder.vehicleCard,
      campaignName: window.raq && window.raq.campaignName
        ? window.raq.campaignName : placeholder.campaignName,
      shoppingTool: window.raq && window.raq.shoppingTool
        ? window.raq.shoppingTool : placeholder.shoppingTool,
      provider: window.raq && window.raq.provider
        ? window.raq.provider : placeholder.provider,
      getLabel: function getLabel(path, disableCheck) {
        const keys = path.split('.');
        let Content = this;
        let result = '';

        for (let i = 0; i < keys.length; i++) {
          if (Content && keys[i] in Content) {
            Content = Content[keys[i]];
          } else {
            result = '(MISSING CONTENT)';
            if (!disableCheck) {
              window.console.warn(`Missing Label: ${path}`);
            }
            break;
          }
        }

        if (Content !== this && result !== '(MISSING CONTENT)') {
          result = Content;
        }

        return result;
      },
    };
  },
};
